import { useNavigate } from 'react-router-dom';
import { BodySmall, Box, Button, H5, Skeleton } from '@parspec/pixel';
import { useCompanyInfoQuery } from './queries';
import { useSubscriptionInfo } from '../PlanAndPayment/queries';

interface HeaderProps {
    isAdminLoading: boolean;
    userProfile: any;
    setIsMaxLocationReachedModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    maxLocationPermitted: number
}

export const Header = (props: HeaderProps) => {
    const { isAdminLoading, userProfile, setIsMaxLocationReachedModalOpen, maxLocationPermitted } = props;
    const { data: companyInfo } = useCompanyInfoQuery();
    const { data: subscriptionInfoData, isLoading: subscriptionInfoLoading } = useSubscriptionInfo();
    const navigate = useNavigate();

    const addLocationHandler = () => {
        if (!companyInfo?.data || !subscriptionInfoData?.data) {
            return;
        }

        const currentNumberOfLocations = companyInfo?.data.length;

        if (currentNumberOfLocations >= maxLocationPermitted) {
            setIsMaxLocationReachedModalOpen(true);
        } else {
            navigate(`/v2/settings/company-locations/add`);
        }
    };
    return (
        <Box>
            <Box display={'flex'} alignItems={'flex-start'} justifyContent={'space-between'} gap={2}>
                <Box>
                    <H5 mb={0.5}>Branch Locations</H5>
                    <BodySmall limit={false} color="text.secondary">
                        If your organization has multiple branch locations, you can add them here.
                        <br /> Projects are linked to a location, a user needs to be associated to a location to access its projects.
                    </BodySmall>
                </Box>
                {isAdminLoading && (
                    <Box>
                        <Skeleton variant="rectangular" height={36} width={231} />
                    </Box>
                )}
                {!isAdminLoading && !subscriptionInfoLoading && userProfile?.data.role === 'admin' && (
                    <Box display={'flex'} gap={1}>
                        <Button variant="outlined" color="secondary" onClick={() => navigate('/v2/settings/user-management?inviteUsers=true&tab=active')}>
                            Invite Users
                        </Button>
                        <Button onClick={addLocationHandler}>Add Locations</Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
};
